import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ThankYouPage = () => {
  const location = useLocation();
  const name = location.state?.name?.split(" ")[0] || null;
  const [show, setShow] = useState(false);

  useEffect(() => {
    // small delay so the checkmark draws in after mount, not on load
    const t = setTimeout(() => setShow(true), 150);
    window.scrollTo(0, 0);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="container-fluid py-5 mb-5">
      <style>{`
        @keyframes ty-draw {
          to { stroke-dashoffset: 0; }
        }
        @keyframes ty-pop {
          0% { transform: scale(0.9); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
        .ty-circle {
          stroke-dasharray: 166;
          stroke-dashoffset: 166;
          transition: stroke-dashoffset 0.6s ease-out;
        }
        .ty-check {
          stroke-dasharray: 48;
          stroke-dashoffset: 48;
          transition: stroke-dashoffset 0.4s ease-out 0.6s;
        }
        .ty-show .ty-circle { stroke-dashoffset: 0; }
        .ty-show .ty-check { stroke-dashoffset: 0; }
        .ty-card {
          opacity: 0;
          animation: ty-pop 0.5s ease-out 0.1s forwards;
        }
        @media (prefers-reduced-motion: reduce) {
          .ty-circle, .ty-check, .ty-card { transition: none; animation: none; opacity: 1; stroke-dashoffset: 0; }
        }
      `}</style>

      <div className="container">
        <div
          className="text-center mx-auto ty-card"
          style={{ maxWidth: "560px" }}
        >
          <div className={show ? "ty-show" : ""}>
            <svg
              width="88"
              height="88"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mb-4"
              aria-hidden="true"
            >
              <circle
                className="ty-circle"
                cx="30"
                cy="30"
                r="26"
                stroke="var(--bs-primary, #0d6efd)"
                strokeWidth="3"
              />
              <path
                className="ty-check"
                d="M18 31L26 39L42 21"
                stroke="var(--bs-primary, #0d6efd)"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <h5 className="text-primary">Message Sent</h5>
          <h1 className="mb-3">
            {name ? `Thanks, ${name}.` : "Thanks for reaching out."}
          </h1>
          <p className="mb-5" style={{ fontSize: "1.05rem", color: "#6c757d" }}>
            Your message has been delivered to our team. A consultant will
            review it and get back to you shortly.
          </p>

          <div className="d-flex gap-3 justify-content-center flex-wrap">
            <Link to="/" className="btn bg-primary text-white py-3 px-5">
              Back to Home
            </Link>
            <Link
              to="/services"
              className="btn btn-outline-primary py-3 px-5"
            >
              Explore Our Services
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;